/**
 * Hamburger menu icon — matches Hugo's bordered rect SVG.
 * Hugo: 36x36 with rounded-[5.5px] border stroke.
 * The border stays light grey on both surfaces; only the bars swap — dark on a
 * light header, light grey in any dark header mode.
 */
export function Hamburger({ className = "size-[2.375rem]" }: { className?: string }) {
  return (
    <svg className={className} width="36" height="36" viewBox="0 0 36 36" fill="none">
      <rect x="0.5" y="0.5" width="35" height="35" rx="5.5" stroke="#D8D8DA" />
      <path
        className="fill-[#1A181D] dark:fill-[#D8D8DA]"
        d="M11.333 20.667V22H24.666V20.667H11.333ZM11.333 17.333V18.667H24.666V17.333H11.333ZM11.333 14V15.333H24.666V14H11.333Z"
      />
    </svg>
  );
}

export function Close({ className = "h-6 w-6" }: { className?: string }) {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  );
}
